import ProductsController from './products-controller'

export default ProductsController
